export default "__VITE_ASSET__ab6b006b__"